import React from 'react';
import CurrencyFormat from '../../Formatters/CurrencyFormat';

export default function DisabilityCoverageAmounts(start,end,increment) {
var amounts = [];
  for (var i = start; i <= end; i += increment) {
    if (i === start) {
      amounts.push({ label: <CurrencyFormat number={i} whole shortK />, value: i });
    } else if (i === end) {
      if (end < 10000000) {
        amounts.push({ label: <CurrencyFormat number={i} whole shortK />, value: i });
      } else {
        amounts.push({ label: <CurrencyFormat number={i} whole shortM />, value: i });
      }
    } else {
      amounts.push({ label: '', value: i });
    }
  }

  return amounts;
}
